<template>
  
        <input type="radio" 
            @change="$emit('update:modelValue', $event.target.value)" v-bind="$attrs"
            class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500 focus:ring-offset-0" />
        <label v-if="label" class="mx-2 block text-sm font-medium text-gray-700">{{ label }}</label>
 
</template>
  
<script setup>
import { inject } from 'vue';

const form = inject('form');

const props = defineProps({

    label: {
        type: String,
        default: ''
    },
    modelValue: {
        type: [String, Number],
        default: ''
    },

}



)



</script>